import _get from 'lodash/get';
export default function translateDataLayerConsumerMarketingSegments() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    demographics: _get(data, 'demographics', 'INCONCLUSIVE'),
    lifeEvents: _get(data, 'lifeEvents', 'INCONCLUSIVE'),
    clusters: _get(data, 'clusters', 'INCONCLUSIVE')
  };
}